/**
 * 条件に応じてconfirmを表示する
 * @param condition confirmを表示する条件
 * @param message
 * @param onConfirm
 * @returns
 */
export const conditionalConfirm = (condition: boolean, message: string, onConfirm: () => void) => {
  if (condition) {
    if (window.confirm(message)) {
      onConfirm();
    }
  } else {
    onConfirm();
  }
};
